import _taggedTemplateLiteral from "/codebuild/output/src748241224/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  right: 999999999px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: 0;\n  top: 58px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: ", "px;\n  color: ", ";\n  margin-left: 14px;\n  margin-top: -4px;\n  g path {\n    fill: none;\n    &:first-child {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  z-index: 2;\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n\n  &.no-shadow {\n    ", " {\n      border-bottom: none;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", "px calc(39px + 100% - 100vw) ", "px ", "px;\n  display: flex;\n  justify-content: space-between;\n  background-color: ", ";\n  border-bottom: solid 2px rgba(0, 115, 119, 0.11);\n  align-items: center;\n  *:focus {\n    outline: none;\n  }\n  ", " {\n    /* This rule is like this to avoid a visual\n    jump when the scroll bar disappears when\n    the drawer opens and scrolling is locked */\n    padding: 9px calc(47px + 100% - 100vw) 9px ", "px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from "styled-components";
import { Cart } from "../Icons";
import { size, colors, mediaQueries } from "../../shared/constants";
var Header = styled.div(_templateObject(), size.md, size.md, size.lg, colors.white, mediaQueries.forTabletHorizontalUp, size.xl1),
    HeaderWrapper = styled.div(_templateObject2(), Header),
    LogoLink = styled.a(_templateObject3()),
    CartStub = styled(Cart)(_templateObject4(), size.lg, colors.green5, colors.green1),
    DrawerContainer = styled.div(_templateObject5());
export var HiddenWrapper = styled.div(_templateObject6());
export { HeaderWrapper, Header, LogoLink, CartStub, DrawerContainer };